import { Pencil } from "lucide-react";
import { ReactNode } from "react";

import { Button } from "../../button";

export function ChoosePencilButton(props: {
  label: ReactNode;
  onClick: () => void;
  disabled?: boolean;
}) {
  return (
    <Button
      variant="tertiary"
      size="sm"
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.label}
      {!props.disabled && <Pencil />}
    </Button>
  );
}
